import type { Destination } from '../interfaces/destination';

interface Props {
    destination: Destination;
    title: string;
    prefix: string;
    path: string;
}

export const StructuredData = ({ destination, title, prefix, path }: Props) => (
    <>
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify({
                    '@context': 'http://schema.org',
                    '@type': 'BreadcrumbList',
                    itemListElement: [
                        {
                            '@type': 'ListItem',
                            position: 1,
                            item: {
                                '@id': `https://www.finn.no${path}`,
                                '@type': 'webpage',
                                name: title,
                            },
                        },
                        {
                            '@type': 'ListItem',
                            position: 2,
                            item: {
                                '@id': `https://www.finn.no${path}${destination.countryPath}/`,
                                '@type': 'webpage',
                                name: destination.country,
                            },
                        },
                    ]
                        .concat(
                            destination.city
                                ? {
                                      '@type': 'ListItem',
                                      position: 3,
                                      item: {
                                          '@id': `https://www.finn.no${path}${destination.countryPath}/${destination.cityPath}/`,
                                          '@type': 'webpage',
                                          name: destination.city,
                                      },
                                  }
                                : null,
                        )
                        .filter((val) => val),
                }),
            }}
        />
        {destination.price ? (
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        '@context': 'https://schema.org/',
                        '@type': 'Product',
                        name: `${prefix} ${destination.city ?? destination.country}`,
                        offers: {
                            '@type': 'AggregateOffer',
                            lowPrice: `${destination.price}`,
                            highPrice: `${destination.price}`,
                            priceCurrency: 'NOK',
                        },
                    }),
                }}
            />
        ) : null}
    </>
);
